<script setup>
//region Imports
import { ref, onMounted, reactive } from 'vue'
import StepHeader from '../components/StepHeader.vue'
//endregion
//region Methods
const readData = () => JSON.parse(localStorage.getItem('tc-claim-data'))

const readSelectedItems = () => JSON.parse(localStorage.getItem('tc-claim-selected-items'))

const readCustomerInformation = () => JSON.parse(localStorage.getItem('tc-claim-customer-information')) ?? {
  firstName: '',
  lastName: '',
  email: '',
  confirmEmail: '',
}

const clickToBack = () => {
  location.replace('#/claim/compensation')
}

const clickToCancel = () => {
  if (!confirm('Are you sure?')) {
    return
  }

  localStorage.removeItem('tc-claim-compensation')
  location.replace('#/order')
}

const saveCustomerInformation = e => {
  e.preventDefault()
  localStorage.setItem('tc-claim-customer-information', JSON.stringify(customerInformation))
  location.replace('#/claim/shipping')
}
//endregion
//region Variables
const data = reactive(readData() ?? {})
const items = reactive(readSelectedItems() ?? [])
let orderNumber = ref(data?.orderNumber)
let customerInformation = reactive(readCustomerInformation() ?? {})
//endregion
//region Lifecycle
onMounted(() => {
  if (!orderNumber.value) {
    location.replace('/')
  }
})
//endregion
</script>

<template>

  <figure class="w-full h-[305px] overflow-hidden bg-no-repeat bg-right bg-cover"
          style="background-image: url(https://cdn.shopify.com/s/files/1/0067/9532/9609/files/DSC01071.png?v=1713213218);">&nbsp;</figure>

  <div class="p-5">

    <step-header :data="data" :items="items"/>

    <main class="max-w-6xl mx-auto">

      <div class="max-w-6xl mx-auto flex flex-row">
        <button type="button" @click="clickToBack">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
            <path d="M8 7L2 13L8 19" stroke="black" stroke-width="1.5"/>
          </svg>
        </button>
        <h1 class="font-bold text-xl" v-text="`Store Credit`"></h1>
      </div>

      <p class="mt-5 text-base">Please confirm your full name and email address that you used to place this order to
        receive your store credit. Once your claim has been approved, your store credit will be sent to the email you
        used while purchasing this order.</p>

      <form method="post" @submit="saveCustomerInformation">

        <input type="text" class="w-full border-b border-gray-400 py-2.5 px-3 my-5" placeholder="First Name" required
               v-model="customerInformation.firstName">
        <input type="text" class="w-full border-b border-gray-400 py-2.5 px-3 my-5" placeholder="Last Name" required
               v-model="customerInformation.lastName">
        <input type="email" class="w-full border-b border-gray-400 py-2.5 px-3 my-5" placeholder="Email" required
               v-model="customerInformation.email">
        <input type="email" class="w-full border-b border-gray-400 py-2.5 px-3 my-5" placeholder="Confirm Email"
               required v-model="customerInformation.confirmEmail">

        <div class="my-10 flex flex-row justify-between">
          <button
              type="button"
              @click="clickToCancel"
              class="py-2.5 px-8 border-b border-tc-creme"
          >Cancel
          </button>
          <button
              type="submit"
              class="py-2.5 px-8 border border-tc-creme"
          >Next
          </button>
        </div>
      </form>

    </main>

  </div>

</template>

<style scoped>
</style>